import { AppThunkAPI } from "@shared/models/redux";

type CallFolderList = () => AppThunkAPI<Promise<string[]>>;

export const fetchInitialFoldersList: CallFolderList = () => async (_dispatch, _state, extra) => {
  const response = await extra<string[]>(`/documents/v1/CustomDataroom/listFolder`, {
    method: "get",
  });

  if (response.status === 204) {
    // return { total: 0, results: [] };
  }

  return response.data;
};
